import { Axios } from "./axiosInstance.js";
import configSettings from "./../config.js";

export const vendorPendingActionsService = () => {
  const baseUrl = configSettings.vendorPortalBaseUrl;


  return Axios.createInstanceWithApiKey().get(`${baseUrl}ActionRequest/GetActionRequests`);
};
